import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { axios } from '../contexts/AuthContext';
import toast from 'react-hot-toast';
import { PROFESSIONS, DISTRICTS, EDUCATION_LIST } from '../constants/masterData';

const SI = { width:'100%',padding:'10px 14px',border:'2px solid rgba(255,107,0,0.2)',borderRadius:12,fontSize:'0.85rem',fontFamily:"'Outfit',sans-serif",background:'rgba(255,255,255,0.8)',outline:'none',transition:'all 0.2s',WebkitAppearance:'none' };
const focus = e=>{e.target.style.borderColor='#FF6B00';e.target.style.boxShadow='0 0 0 4px rgba(255,107,0,0.1)';e.target.style.background='white';};
const blur  = e=>{e.target.style.borderColor='rgba(255,107,0,0.2)';e.target.style.boxShadow='none';e.target.style.background='rgba(255,255,255,0.8)';};

const Label = ({children}) => <label style={{display:'block',fontSize:'0.7rem',fontWeight:700,color:'#BF360C',marginBottom:5,textTransform:'uppercase',letterSpacing:'0.7px'}}>{children}</label>;

export default function VoterSearch() {
  const navigate = useNavigate();
  const [form, setForm] = useState({epic_id:'',voter_id:'',name:'',relation_name:'',house_number:'',booth_number:'',district:'',area:'',mobile:'',profession:'',degree:''});
  const [results, setResults] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [areas, setAreas] = useState([]);
  const [listening, setListening] = useState(false);
  const [showFilters, setShowFilters] = useState(true);

  useEffect(() => {
    if(form.district) axios.get(`/stats/areas?district=${form.district}`).then(r=>setAreas(r.data)).catch(()=>{});
  }, [form.district]);

  const handleSearch = async (p=1) => {
    if(!Object.values(form).some(v=>String(v).trim()!=='')){toast.error('Enter at least one search field');return;}
    setLoading(true);
    try {
      const params={...form,page:p,limit:50};
      Object.keys(params).forEach(k=>{if(!params[k])delete params[k];});
      const {data} = await axios.get('/voters/search',{params});
      setResults(data.voters);setTotal(data.total);setPages(data.pages);setPage(p);
      if(data.total===0)toast('No voters found',{icon:'🔍'});
      else if(p===1)setShowFilters(false);
    } catch{toast.error('Search failed');}
    finally{setLoading(false);}
  };

  const handleReset = () => {setForm({epic_id:'',voter_id:'',name:'',relation_name:'',house_number:'',booth_number:'',district:'',area:'',mobile:'',profession:'',degree:''});setResults([]);setTotal(0);setShowFilters(true);};

  const startVoice = () => {
    if(!('webkitSpeechRecognition' in window)&&!('SpeechRecognition' in window)){toast.error('Voice not supported');return;}
    const SR=window.SpeechRecognition||window.webkitSpeechRecognition;
    const rec=new SR();rec.lang='te-IN';
    rec.onstart=()=>setListening(true);rec.onend=()=>setListening(false);
    rec.onresult=e=>setForm(f=>({...f,name:e.results[0][0].transcript}));
    rec.onerror=()=>{setListening(false);toast.error('Voice error');};
    rec.start();
  };

  const f=(k,v)=>setForm(p=>({...p,[k]:v}));

  return (
    <div style={{minHeight:'100vh',background:'linear-gradient(160deg,#FFF4ED,#FFF8F0)',fontFamily:"'Outfit',sans-serif"}}>
      <div className="app-header">
        <div style={{display:'flex',alignItems:'center',gap:10}}>
          <button className="back-btn" onClick={()=>navigate('/')}>←</button>
          <div>
            <div style={{fontFamily:"'Baloo 2',sans-serif",fontWeight:700,fontSize:'1.1rem',color:'white'}}>🔍 Search Voter</div>
            {total>0&&<div style={{fontSize:'0.7rem',opacity:.85,color:'white'}}>{total.toLocaleString()} results</div>}
          </div>
        </div>
        {results.length>0&&(
          <button onClick={()=>setShowFilters(!showFilters)} style={{background:'rgba(255,255,255,0.2)',border:'1px solid rgba(255,255,255,0.4)',color:'white',padding:'6px 14px',borderRadius:99,cursor:'pointer',fontWeight:600,fontSize:'0.78rem'}}>
            {showFilters?'Hide':'Show'} Filters
          </button>
        )}
      </div>

      <div style={{maxWidth:1000,margin:'0 auto',padding:'20px 24px'}}>

        {showFilters && (
          <div style={{background:'rgba(255,255,255,0.88)',backdropFilter:'blur(16px)',borderRadius:24,padding:'24px',marginBottom:20,boxShadow:'0 8px 40px rgba(255,107,0,0.1)',border:'1px solid rgba(255,255,255,0.7)',animation:'fadeInUp 0.4s ease forwards'}}>
            <div style={{fontFamily:"'Baloo 2',sans-serif",fontSize:'1rem',fontWeight:700,color:'#BF360C',marginBottom:18}}>🔍 Search Filters</div>

            <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(200px,1fr))',gap:'0 20px'}}>
              {/* UU ID */}
              <div style={{marginBottom:14}}>
                <Label>UU ID</Label>
                <input style={SI} placeholder="e.g. TCV0549263" value={form.epic_id} onChange={e=>f('epic_id',e.target.value)} onFocus={focus} onBlur={blur}/>
              </div>

              {/* Voter ID */}
              <div style={{marginBottom:14}}>
                <Label>Voter ID</Label>
                <input style={SI} placeholder="e.g. AP/12/34/567890" value={form.voter_id} onChange={e=>f('voter_id',e.target.value)} onFocus={focus} onBlur={blur}/>
              </div>

              {/* Name with voice */}
              <div style={{marginBottom:14}}>
                <Label>Voter Name</Label>
                <div style={{position:'relative'}}>
                  <input style={{...SI,paddingRight:48}} placeholder="Full name" value={form.name} onChange={e=>f('name',e.target.value)} onFocus={focus} onBlur={blur}/>
                  <button onClick={startVoice} style={{position:'absolute',right:6,top:'50%',transform:'translateY(-50%)',background:listening?'#E55100':'linear-gradient(135deg,#E55100,#FF6B00)',color:'white',border:'none',borderRadius:8,padding:'5px 9px',cursor:'pointer',fontSize:'0.78rem',fontWeight:700}}>
                    {listening?'⏹':'🎤'}
                  </button>
                </div>
                {listening&&<div style={{fontSize:'0.7rem',color:'#FF6B00',marginTop:3,fontWeight:600}}>🔴 Listening...</div>}
              </div>

              <div style={{marginBottom:14}}>
                <Label>Relation Name</Label>
                <input style={SI} placeholder="Father/Husband name" value={form.relation_name} onChange={e=>f('relation_name',e.target.value)} onFocus={focus} onBlur={blur}/>
              </div>
              <div style={{marginBottom:14}}>
                <Label>House Number</Label>
                <input style={SI} placeholder="House No." value={form.house_number} onChange={e=>f('house_number',e.target.value)} onFocus={focus} onBlur={blur}/>
              </div>
              <div style={{marginBottom:14}}>
                <Label>Booth Number</Label>
                <input type="number" style={SI} placeholder="Booth #" value={form.booth_number} onChange={e=>f('booth_number',e.target.value)} onFocus={focus} onBlur={blur}/>
              </div>
              <div style={{marginBottom:14}}>
                <Label>Mobile Number</Label>
                <input type="tel" maxLength={10} style={SI} placeholder="10-digit" value={form.mobile} onChange={e=>f('mobile',e.target.value.replace(/\D/g,'').slice(0,10))} onFocus={focus} onBlur={blur}/>
              </div>

              {/* District */}
              <div style={{marginBottom:14}}>
                <Label>District</Label>
                <select style={SI} value={form.district} onChange={e=>f('district',e.target.value)} onFocus={focus} onBlur={blur}>
                  <option value="">-- Select District --</option>
                  {DISTRICTS.map(d=><option key={d} value={d}>{d}</option>)}
                </select>
              </div>

              {/* Area — NEW */}
              <div style={{marginBottom:14}}>
                <Label>Area / Section 🆕</Label>
                {areas.length>0?(
                  <select style={SI} value={form.area} onChange={e=>f('area',e.target.value)} onFocus={focus} onBlur={blur}>
                    <option value="">-- Select Area --</option>
                    {areas.map(a=><option key={a} value={a}>{a}</option>)}
                  </select>
                ):(
                  <input style={SI} placeholder="Area / locality" value={form.area} onChange={e=>f('area',e.target.value)} onFocus={focus} onBlur={blur}/>
                )}
              </div>

              {/* Profession — NEW */}
              <div style={{marginBottom:14}}>
                <Label>Profession 🆕</Label>
                <select style={SI} value={form.profession} onChange={e=>f('profession',e.target.value)} onFocus={focus} onBlur={blur}>
                  <option value="">-- Select Profession --</option>
                  {PROFESSIONS.map(p=><option key={p} value={p}>{p}</option>)}
                </select>
              </div>

              {/* Education — NEW */}
              <div style={{marginBottom:14}}>
                <Label>Education 🆕</Label>
                <select style={SI} value={form.degree} onChange={e=>f('degree',e.target.value)} onFocus={focus} onBlur={blur}>
                  <option value="">-- Select Education --</option>
                  {EDUCATION_LIST.map(e=><option key={e} value={e}>{e}</option>)}
                </select>
              </div>
            </div>

            <div style={{display:'flex',gap:12,marginTop:8}}>
              <button onClick={handleReset} style={{flex:1,padding:'12px',border:'2px solid rgba(255,107,0,0.3)',borderRadius:14,background:'transparent',color:'#E55100',fontWeight:700,fontSize:'0.88rem',cursor:'pointer',fontFamily:"'Outfit',sans-serif",transition:'all 0.2s'}} onMouseEnter={e=>e.target.style.background='rgba(255,107,0,0.06)'} onMouseLeave={e=>e.target.style.background='transparent'}>↺ Reset</button>
              <button onClick={()=>handleSearch(1)} disabled={loading} style={{flex:3,padding:'12px',border:'none',borderRadius:14,background:'linear-gradient(135deg,#E55100,#FF6B00)',color:'white',fontWeight:700,fontSize:'0.92rem',cursor:'pointer',fontFamily:"'Outfit',sans-serif",boxShadow:'0 4px 16px rgba(255,107,0,0.4)',display:'flex',alignItems:'center',justifyContent:'center',gap:8}}>
                {loading?<><span style={{width:14,height:14,border:'2px solid rgba(255,255,255,0.4)',borderTopColor:'white',borderRadius:'50%',display:'inline-block',animation:'spin 0.7s linear infinite'}}/>Searching...</>:'🔍 Search'}
              </button>
            </div>
          </div>
        )}

        {results.length>0&&(
          <>
            <div style={{fontFamily:"'Baloo 2',sans-serif",fontSize:'1rem',fontWeight:700,color:'#BF360C',marginBottom:14}}>📋 Voters ({total.toLocaleString()})</div>
            {results.map(voter=>(
              <div key={voter.id} className="voter-list-item" onClick={()=>navigate(`/voter/${voter.id}`)}>
                <div className={`voter-avatar ${voter.gender==='F'?'avatar-f':voter.gender==='M'?'avatar-m':'avatar-o'}`}>{voter.name.charAt(0)}</div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontWeight:700,fontSize:'0.92rem',marginBottom:2,color:'#1A0A00'}}>{voter.name}</div>
                  <div style={{fontSize:'0.78rem',color:'#9E6040'}}>{voter.relation_name||'—'}</div>
                  <div style={{display:'flex',gap:6,marginTop:5,flexWrap:'wrap'}}>
                    <span className="tag">Booth {voter.booth_number}</span>
                    <span className="tag">S.No {voter.serial_number}</span>
                    {voter.district&&<span className="tag">{voter.district}</span>}
                  </div>
                </div>
                <div style={{textAlign:'right',flexShrink:0}}>
                  <div className={`badge badge-${voter.gender==='M'?'m':voter.gender==='F'?'f':'none'}`}>{voter.gender}/{voter.age}</div>
                  {voter.mobile&&<div style={{fontSize:'0.7rem',color:'#C4A090',marginTop:4}}>..{voter.mobile.slice(-4)}</div>}
                </div>
              </div>
            ))}
            {pages>1&&(
              <div className="pagination">
                <button className="page-btn" onClick={()=>handleSearch(page-1)} disabled={page===1}>‹</button>
                <span style={{fontSize:'0.85rem',color:'#9E6040',fontWeight:600}}>Page {page} of {pages}</span>
                <button className="page-btn" onClick={()=>handleSearch(page+1)} disabled={page===pages}>›</button>
              </div>
            )}
          </>
        )}
      </div>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}} @keyframes fadeInUp{from{transform:translateY(20px);opacity:0}to{transform:translateY(0);opacity:1}}`}</style>
    </div>
  );
}